import { render, staticRenderFns } from "./WebPartPricePlanSetting.vue?vue&type=template&id=1cdfac1e&"
import script from "./WebPartPricePlanSetting.vue?vue&type=script&lang=js&"
export * from "./WebPartPricePlanSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cdfac1e')) {
      api.createRecord('1cdfac1e', component.options)
    } else {
      api.reload('1cdfac1e', component.options)
    }
    module.hot.accept("./WebPartPricePlanSetting.vue?vue&type=template&id=1cdfac1e&", function () {
      api.rerender('1cdfac1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartPricePlanSetting.vue"
export default component.exports